import { render } from "./Cargador.vue?vue&type=template&id=6b60498e"
import script from "./Cargador.vue?vue&type=script&lang=js"
export * from "./Cargador.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__